import script from "./EntityChangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityChangeView.vue?vue&type=script&setup=true&lang=js"

import "./EntityChangeView.vue?vue&type=style&index=0&id=71b67a54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b67a54"]])

export default __exports__